import React, { useContext, useEffect, useState } from "react";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import config from "../../../config/config";
import axios from "axios";
import moment from "moment";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { CUSTOM_SELECT_DROPDOWN_RECEIPT_STYLE } from "../../../common/Constant";
import Select from "react-select";
import { toastSuccess } from "../../../common/Toast";
import html2pdf from "html2pdf.js";

function PrintSaleReceipts() {
  const token = localStorage.getItem("Token");
  const [searchParams] = useSearchParams();
  const idsParam = searchParams.get("id"); // "123,456,789"
  const invoiceIds = idsParam ? idsParam.split(",") : [];

  const {
    CurrencySymbol,
    FractionDigits,
    isManageSale,
    isManagePOSSale,
    dateFormate,
  } = useContext(AppContext);
  const ITEMS_PER_PAGE = 20;

  const [loading, setLoading] = useState(false);
  const [subCompany, setsubCompany] = useState([]);
  const [SelectedSubCompany, setSelectedSubCompany] = useState("");
  const [salesData, setSalesData] = useState([]);
  const [buttonPrintLable, setbuttonPrintLable] = useState(false);

  console.log(loading, "loading check");

  const handlePrintAllInvoice = async (e, type) => {
    e.preventDefault();
    if (salesData?.length == 0) return;
    setLoading(true);

    try {
      const masterContainer = document.createElement("div");
      salesData?.forEach((responseData, index) => {
        let headerElement = document.querySelector("#header" + index);
        let header1Element = document.querySelector("#headerone" + index);
        let footerElement = document.getElementById("footer" + index);
        let TotalfooterElement = document.getElementById("Totalfooter" + index);

        if (!headerElement || !header1Element) {
          console.error("Header or Header1 element is missing.");
          return;
        }

        footerElement.style.padding = "0 20px";
        footerElement.style.marginTop = "25px";

        const discountEntireSale = Number(
          responseData?.SalesItems[0]?.Discountpercent || "0"
        );
        const showDiscountColumn = discountEntireSale > 0;
        const salesItems = responseData?.SalesItems || [];
        const itemsPerPage = 19;
        const firstPageItemsCount = 13;
        const specialFirstPageItemsCount = 13;
        const totalItems = salesItems.length;
        let carryOverSum = 0;
        let currentIndex = 1;
        let specialfooter = totalItems > 7 && totalItems <= 13;

        const chunkArray = (array, specialCase) => {
          const chunks = [];
          if (specialCase) {
            if (array.length > specialFirstPageItemsCount) {
              chunks.push(array.slice(0, specialFirstPageItemsCount));
              chunks.push(array.slice(specialFirstPageItemsCount));
            } else {
              chunks.push(array);
            }
          } else {
            if (array.length > 0) {
              chunks.push(array.slice(0, firstPageItemsCount));
            }
            for (
              let i = firstPageItemsCount;
              i < array.length;
              i += itemsPerPage
            ) {
              chunks.push(array.slice(i, i + itemsPerPage));
            }
          }
          return chunks;
        };

        const chunks = chunkArray(
          salesItems,
          totalItems >= 7 && totalItems <= 14
        );

        let invoiceContainer = document.createElement("div");
        // invoiceContainer.style.width = "794px"; // A4 width at 96 DPI
        // invoiceContainer.style.margin = "0 auto";
        invoiceContainer.style.pageBreakInside = "avoid"; // avoid page cut in middle of container
        let totalPagesForInvoice = 0;

        chunks.forEach((chunk, pageIndex) => {
          let page = document.createElement("div");
          const isLastInvoice = index === salesData.length - 1;
          const isLastPage = pageIndex === chunks.length - 1;

          // if (!(isLastInvoice && isLastPage)) {
          //   page.style.pageBreakAfter = "always";
          // }
          page.style.pageBreakAfter = "always";


          page.style.padding = "20px";

          if (pageIndex === 0) {
            page.appendChild(headerElement.cloneNode(true));
          } else {
            page.appendChild(header1Element.cloneNode(true));
          }

          let table = document.createElement("table");
          table.className = "table mt-1";
          table.style.width = "100%";
          table.style.tableLayout = "fixed";
          table.style.marginBottom = "10px";
          table.style.fontSize = "5px";
          table.style.borderCollapse = "collapse";
          table.style.marginTop = "80px";

          let thead = document.createElement("thead");
          thead.innerHTML = `
          <tr>
            <th style="width: 10%; background-color: #1a2649; color: #ffffff; padding: 7px; text-align: center">#</th>
            ${
              showDiscountColumn
                ? `<th style="width: 30%; background-color: #1a2649; color: #ffffff; padding: 7px;">Product/Services</th>`
                : `<th style="width: 35%; background-color: #1a2649; color: #ffffff; padding: 7px;">Product/Services</th>`
            }
            ${
              showDiscountColumn
                ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>`
                : `<th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Quantity</th>`
            }
            ${
              showDiscountColumn
                ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>`
                : `<th style="width: 20%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Price</th>`
            }
            ${
              showDiscountColumn
                ? `<th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Discount %</th>`
                : ``
            }
            <th style="width: 15%; background-color: #1a2649; color: #ffffff; text-align: right; padding: 7px;">Total</th>
          </tr>`;

          let tbody = document.createElement("tbody");

          chunk.forEach((item) => {
            let row = document.createElement("tr");
            row.style.padding = "2px";

            const itemTotal = Number(item.Total);
            carryOverSum += itemTotal;

            row.innerHTML = `
            <td style="display: flex; justify-content: center; padding: 2px; color: black;">${currentIndex++}</td>
            <td style="text-align: left; padding: 2px; color: black;">${
              type == "ReplaceName"
                ? item?.ItemVariationPrintName ||
                  item?.ItemPrintName ||
                  item?.ItemVariationName ||
                  item?.ItemName
                : item?.ItemVariationName || item?.ItemName
            }</td>
            <td style="text-align: right; padding: 2px;"></td>
            <td style="text-align: right; padding: 2px;"></td>
            <td style="text-align: right; padding: 2px;"></td>
            <td style="text-align: right; padding: 2px;"></td>
          `;

            let detailsRow = document.createElement("tr");
            detailsRow.style.padding = "2px";
            detailsRow.style.borderBottom = "0.1px solid #dcdcdc";

            detailsRow.innerHTML = `
            <td style="padding: 2px;"></td>
            <td style="text-align: left; padding: 2px; color: black;"></td>
            <td style="text-align: right; padding: 2px; color: black;">${Number(
              item.Quantitypurchased
            ).toFixed(2)}</td>
            <td style="text-align: right; padding: 2px; color: black;">$ ${Number(
              item.Itemunitprice
            ).toFixed(2)}</td>
            ${
              discountEntireSale
                ? `<td style="text-align: right; padding: 2px; color: black;">${Number(
                    item.Discountpercent
                  ).toFixed(2)}</td>`
                : ``
            }
            <td style="text-align: right; padding: 2px; color: black;">$ ${itemTotal.toFixed(
              2
            )}</td>
          `;

            tbody.appendChild(row);
            tbody.appendChild(detailsRow);
          });

          table.appendChild(thead);
          table.appendChild(tbody);

          let tfoot = document.createElement("tfoot");
          tfoot.innerHTML = `
          <tr>
            <td colspan="${
              showDiscountColumn ? 3 : 2
            }" style="text-align: right; padding: 2px; margin-top: -12px;">
              Page ${pageIndex + 1} of ${chunks.length}
            </td>
          </tr>`;

          table.appendChild(tfoot);
          page.appendChild(table);

          invoiceContainer.appendChild(page);
          totalPagesForInvoice++;


          // if (pageIndex === chunks.length - 1) {
          //   page.appendChild(TotalfooterElement.cloneNode(true));
          //   if (specialfooter) {
          //     let footerPage = document.createElement("div");
          //     footerPage.style.pageBreakAfter = "always";
          //     footerPage.appendChild(footerElement.cloneNode(true));
          //     invoiceContainer.appendChild(footerPage);
          //   } else {
          //     page.appendChild(footerElement.cloneNode(true));
          //   }
          // }

          if (pageIndex === chunks.length - 1) {
            page.appendChild(TotalfooterElement.cloneNode(true));

            const isHeaderOne = pageIndex !== 0;
            const isCrowdedPage = chunk.length > 13;

            if (specialfooter || (isHeaderOne && isCrowdedPage)) {
              let footerPage = document.createElement("div");
              footerPage.style.pageBreakAfter = "always";
              footerPage.appendChild(footerElement.cloneNode(true));
              invoiceContainer.appendChild(footerPage);
              totalPagesForInvoice++;
            } else {
              page.appendChild(footerElement.cloneNode(true));
            }
          }

        });

        masterContainer.appendChild(invoiceContainer);

        if (totalPagesForInvoice % 2 !== 0) {
          const blankPage = document.createElement("div");
          blankPage.style.height = "100%";
          blankPage.style.pageBreakAfter = "always";
          masterContainer.appendChild(blankPage);
        }

      });

      const currentDateTime = moment().format("YYYY-MM-DD_HH-mm-ss");
      const fileName =
        salesData?.length == 1
          ? `#${salesData[0]}_Invoice_${currentDateTime}.pdf`
          : `All_Invoices_${currentDateTime}.pdf`;
      const opt = {
        margin: 0,
        filename: fileName,
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: false,
          logging: false,
          windowWidth: 10000, // forces consistent rendering width
          scrollX: 0,
          scrollY: 0,
        },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };

      await html2pdf()
        .from(masterContainer)
        .set(opt)
        .output("blob")
        .then((pdfBlob) => {
          const pdfUrl = URL.createObjectURL(pdfBlob); // Create a URL for the Blob
          window.open(pdfUrl, "_blank"); // Open the PDF in a new tab
        });
    } catch (err) {
      console.error("Error while generating combined PDF:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubCompanyLocations = async () => {
    try {
      const response = await axios.get(
        `${config.locationBaseUrl}/locations/getsubcompany`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      );

      const data = response?.data?.ResponseData || [];

      const subCompanyOptions = data
        .filter((item) => item.IsDelete === 0)
        .map((el) => ({
          value: el.ID,
          label: el.Name,
        }));

      setsubCompany(subCompanyOptions);

      // Set default selected where ID === 1 and IsDelete === 0
      const defaultItem = data.find(
        (item) => item.ID === 1 && item.IsDelete == 0
      );

      if (defaultItem) setSelectedSubCompany(defaultItem.Name);
    } catch (error) {
      console.error("Error fetching sub company locations:", error);
    }
  };

  const fetchPrintAllInvoices = async () => {
    try {
      const allResponses = await Promise.all(
        invoiceIds.map(async (el) => {
          const res = await axios.get(
            `${config.salesconfigBaseUrl}/sales/lookupreceipt?saleid=${el}&type=approve`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          );
          return res.data.ResponseData;
        })
      );
      console.log("All invoice responses:", allResponses);
      setSalesData(allResponses);
    } catch (err) {
      console.error("Error fetching invoices:", err);
    }
  };

  useEffect(() => {
    fetchSubCompanyLocations();
    fetchPrintAllInvoices();
  }, []);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <Link
            className="btn btn-sm btn-secondary me-1 mb-5"
            onClick={(e) => handlePrintAllInvoice(e, "ItemName")}
          >
            Print All Invoice
          </Link>
          <Link
            className="btn btn-sm btn-secondary me-1 mb-5"
            onClick={(e) => {
              e.preventDefault();
              setbuttonPrintLable(!buttonPrintLable);
            }}
          >
            {buttonPrintLable ? "Check Original Name" : "Check Replace Name"}
          </Link>
          <Link
            className="btn btn-sm btn-secondary me-1 mb-5"
            onClick={(e) => handlePrintAllInvoice(e, "ReplaceName")}
          >
            Print Replace Name Invoice
          </Link>
          <div style={{ border: "none" }} className="btn mt-0 me-1 mb-5">
            <div style={{ width: "185px" }}>
              <Select
                options={subCompany}
                value={subCompany.find((el) => el.label === SelectedSubCompany)}
                onChange={(e) => setSelectedSubCompany(e?.label || "")}
                // isClearable={true}
                placeholder="Select Sub Company"
                className="w-100"
                styles={CUSTOM_SELECT_DROPDOWN_RECEIPT_STYLE}
              />
            </div>
          </div>

          {salesData?.map((responseData, index) => {
            let shippingDelivaryAddress = null;

            const shippingAdress =
              Number(responseData?.SalesDetails[0]?.shippingaddress) || 0;

            const saleshippingdelivaryaddress =
              responseData?.SalesDeliveryshippingDetails?.length > 0
                ? responseData.SalesDeliveryshippingDetails
                : [];

            if (shippingAdress > 0) {
              const matchedAddress = saleshippingdelivaryaddress.find(
                (item) => item.ID == shippingAdress
              );
              shippingDelivaryAddress = matchedAddress;
            }

            const totalPages = Number(
              Math.ceil(responseData.SalesItems?.length / ITEMS_PER_PAGE)
            );

            const salesItemLength = responseData?.SalesItems?.length;

            let sumss = 0;
            for (let i = 0; i < salesItemLength; i++) {
              const quantity = responseData?.SalesItems[i]?.Quantitypurchased
                ? Number(responseData?.SalesItems[i].Quantitypurchased)
                : 0;
              sumss += quantity;
            }

            return (
              <div id="print" className="receipt-card-body">
                {/* Sales Receipt */}
                <div className="card-body">
                  {/* Header */}
                  <div id={`header` + index}>
                    <div
                      style={{
                        color: "#000 !important",
                        textAlign: "left !important",
                      }}
                    >
                      <div className="row">
                        <div
                          className="col-md-5"
                          style={{ marginLeft: "20px", color: "black" }}
                        >
                          <p
                            className="fw-bold"
                            style={{
                              fontFamily: "Inter, sans-serif",
                              fontSize: "20px",
                              color: "black",
                            }}
                          >
                            {SelectedSubCompany}
                          </p>{" "}
                          {/* <br /> */}
                          <p
                            style={{
                              textAlign: "left",
                              fontFamily: "Inter, sans-serif",
                              fontSize: "20px",
                              color: "black",
                            }}
                          >
                            {" "}
                            {SelectedSubCompany}
                          </p>
                          {/* <br /> */}
                          <p
                            style={{
                            //   textAlign: "right",
                              fontFamily: "Inter, sans-serif",
                              color: "black",
                            }}
                          >
                            {responseData?.CompanyDetails &&
                              responseData?.CompanyDetails[0]?.Website}
                          </p>{" "}
                        </div>
                        <div className="col-md-2"></div>
                        <div
                          className="col-md-4"
                          style={{
                            textAlign: "start",
                            color: "black",
                            paddingLeft: "50px",
                          }}
                        >
                          <div
                            className="fw-bold"
                            style={{
                              fontFamily: "Inter, sans-serif",
                              fontSize: "14px",
                              color: "black",
                            }}
                          ></div>

                          <div
                            className="fw-bold"
                            style={{
                              fontFamily: "Inter, sans-serif",
                              fontSize: "18px",
                              color: "black",
                            }}
                          >
                            Invoice No -{" "}
                            {responseData?.SalesDetails &&
                              responseData?.SalesDetails[0]?.Posid}
                          </div>
                        </div>
                      </div>

                      <hr></hr>
                      <div
                        className="row"
                        style={{
                          marginTop: "0px",
                          marginTop: "-8px",
                          color: "black",
                        }}
                      >
                        <div className="col-md-4">
                          {responseData?.CustomerDetails?.map((item, index) => {
                            return (
                              <>
                                <p
                                  className="fw-bold mt-1"
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  Bill To :
                                  {/* {item?.Name}({item?.personid}) */}
                                </p>
                                {/* <br /> */}
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  Company Name:{" "}
                                  <b style={{ color: "black" }}>
                                    {item?.personid} - {item?.Companyname}
                                  </b>
                                </p>
                                {/* <br /> */}
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  Address :
                                  {item?.Address && `${item.Address}, `}
                                  {item?.Address2 && `${item.Address2}, `}
                                  {item?.city && `${item.city}, `}
                                  {item?.StateProvince &&
                                    `${item.StateProvince} `}
                                  {item?.Zip &&
                                    item.Zip !== "" &&
                                    item.Zip !== null &&
                                    `${item.Zip}, `}
                                  {item?.Country && `${item.Country}`}
                                </p>

                                {/* <br /> */}
                                {/* <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  city: ({item?.city})
                                </p> */}
                                {/* <br /> */}
                                {/* <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  Zipcode: {item?.Zip}
                                </p> */}
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  Phone No :{" "}
                                  {item?.PhoneNumber
                                    ? item.PhoneNumber.replace(
                                        /(\d{3})(\d{3})(\d{4})/,
                                        "($1) $2-$3"
                                      )
                                    : ""}
                                  {/* Phone No : {item?.PhoneNumber}({item?.Email}) */}
                                </p>
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  Email: {item.Email}
                                </p>
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  REP : {item?.REP}
                                </p>
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  Route : {item?.Route}
                                </p>
                                {/* <br /> */}
                                <p
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  LEVEL : {item?.LEVEL}
                                </p>
                              </>
                            );
                          })}
                        </div>

                        <div className="col-md-4">
                          {responseData?.CustomerDetails?.map((item, index) => {
                            let finalDefaultAdd = "";
                            if (responseData.SalesDeliveryDetails?.length > 0) {
                              const SaleDefaultAddress =
                                responseData?.SalesDeliveryDetails[0];
                              const {
                                Address1,
                                Address2,
                                City,
                                Zip,
                                State,
                                Country,
                              } = SaleDefaultAddress;
                              finalDefaultAdd = `${
                                Address1 ? Address1 + ", " : ""
                              }${Address2 ? Address2 + ", " : ""}${
                                City ? City + ", " : ""
                              }
                                 ${
                                   Zip && State ? State + " " + Zip + ", " : ""
                                 }${Country ? Country : ""}`;
                              // finalDefaultAdd = `${Address1} ${Address2} ${City} ${Zip} ${State} ${Country}`;
                            }

                            return (
                              <div key={index}>
                                <p
                                  className="text-bold mt-1"
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "black",
                                    }}
                                  >
                                    Ship To:
                                  </span>
                                  <br />
                                  Company Name : {item?.Companyname}
                                </p>

                                <p
                                  className="text-bold mt-1"
                                  style={{
                                    fontFamily: "Inter, sans-serif",
                                    color: "black",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "black",
                                    }}
                                  >
                                    Shipping Address:{" "}
                                  </span>
                                  {shippingDelivaryAddress
                                    ? `${
                                        shippingDelivaryAddress?.Address1
                                          ? shippingDelivaryAddress.Address1 +
                                            ", "
                                          : ""
                                      }${
                                        shippingDelivaryAddress?.Address2
                                          ? shippingDelivaryAddress.Address2 +
                                            ", "
                                          : ""
                                      }${
                                        shippingDelivaryAddress?.City
                                          ? shippingDelivaryAddress.City + ", "
                                          : ""
                                      }${
                                        shippingDelivaryAddress?.StateProvince
                                          ? shippingDelivaryAddress.StateProvince +
                                            ", "
                                          : ""
                                      }${
                                        shippingDelivaryAddress?.Zip
                                          ? shippingDelivaryAddress.Zip + ", "
                                          : ""
                                      }${
                                        shippingDelivaryAddress?.Country
                                          ? shippingDelivaryAddress.Country
                                          : ""
                                      }`
                                    : responseData?.CustomerDetails?.map(
                                        (item, index) => (
                                          <span key={index}>
                                            {item?.Address &&
                                              `${item.Address}, `}
                                            {item?.Address2 &&
                                              `${item.Address2}, `}
                                            {item?.city && `${item.city}, `}
                                            {item?.StateProvince &&
                                              `${item.StateProvince} `}
                                            {item?.Zip &&
                                              item.Zip !== "" &&
                                              item.Zip !== null &&
                                              `${item.Zip}, `}
                                            {item?.Country && `${item.Country}`}
                                          </span>
                                        )
                                      )}
                                </p>
                              </div>
                            );
                          })}
                        </div>

                        <div className="col-md-4">
                          <div className="row">
                            <p
                              style={{
                                alignItems: "start",
                                fontFamily: "Inter, sans-serif",
                                display: "flex",
                                color: "black",
                              }}
                              className="col-md-12"
                            >
                              Invoice Date:{" "}
                              {responseData?.SalesDetails &&
                                moment(
                                  responseData?.SalesDetails[0]?.Saletime
                                ).format(`${dateFormate.toUpperCase()}`)}
                            </p>
                          </div>

                          <div className="row">
                            <p
                              className="col-md-12"
                              style={{
                                fontFamily: "Inter, sans-serif",
                                color: "black",
                              }}
                            >
                              Type:{" "}
                              {responseData.SalesDetails &&
                                (responseData.SalesDetails[0]?.SalesType ==
                                "Sale"
                                  ? "Invoice"
                                  : responseData.SalesDetails[0]?.SalesType)}
                            </p>
                          </div>
                          {/* <hr /> */}
                          <div className="row">
                            <p
                              style={{
                                alignItems: "start",
                                display: "flex",
                                fontFamily: "Inter, sans-serif",
                                color: "black",
                              }}
                              className="col-md-12"
                            >
                              Terms:{" "}
                              {responseData?.SalesDetails &&
                                (responseData?.SalesDetails[0]?.termsname
                                  ? responseData?.SalesDetails[0]?.termsname
                                  : "NA")}
                            </p>
                          </div>
                          {/* <hr /> */}
                          <div className="row">
                            <p
                              style={{
                                alignItems: "start",
                                fontFamily: "Inter, sans-serif",
                                display: "flex",
                                color: "black",
                              }}
                              className="col-md-12"
                            >
                              Due Date:{" "}
                              {responseData.SalesDetails &&
                                moment(
                                  responseData.SalesDetails[0]?.DueDate
                                ).format(`${dateFormate.toUpperCase()}`)}
                            </p>
                          </div>

                          <div className="row">
                            <p
                              style={{
                                alignItems: "start",
                                display: "flex",
                                fontFamily: "Inter, sans-serif",
                                color: "black",
                              }}
                              className="col-md-12"
                            >
                              Created Date:{" "}
                              {responseData?.SalesDetails &&
                                moment(
                                  responseData?.SalesDetails[0]?.CreatedDate
                                ).format(`${dateFormate.toUpperCase()} h:mm A`)}
                            </p>
                          </div>

                          <div className="row">
                            <p
                              className="col-md-12"
                              style={{
                                fontFamily: "Inter, sans-serif",
                                color: "black",
                              }}
                            >
                              Created BY :{" "}
                              {responseData.SalesDetails[0]?.CreatedName}
                            </p>
                          </div>

                          <div className="row">
                            <p
                              style={{
                                alignItems: "start",
                                display: "flex",
                                fontFamily: "Inter, sans-serif",
                                color: "black",
                              }}
                              className="col-md-12"
                            >
                              Modified Date:{" "}
                              {responseData?.SalesDetails &&
                              responseData?.SalesDetails[0]?.ModifiedDate
                                ? moment(
                                    responseData?.SalesDetails[0]?.ModifiedDate
                                  ).format(
                                    `${dateFormate.toUpperCase()} h:mm A`
                                  )
                                : ""}
                            </p>
                          </div>

                          <div className="row">
                            <p
                              className="col-md-12"
                              style={{
                                fontFamily: "Inter, sans-serif",
                                color: "black",
                              }}
                            >
                              Modified BY :{" "}
                              {responseData.SalesDetails[0]?.ModifideName}
                            </p>
                          </div>
                          {/* <p
                            id="page-no"
                            style={{
                              fontFamily: "Inter, sans-serif",
                              display: "none",
                            }}
                          >
                            Page No : {currentPage}/{totalPages}
                          </p> */}
                        </div>
                      </div>
                    </div>
                    <hr />
                  </div>

                  <div style={{ display: "none" }}>
                    <div id={`headerone` + index}>
                      <div
                        style={{
                          color: "#000 !important",
                          textAlign: "left !important",
                        }}
                      >
                        <div className="row">
                          <div
                            className="col-md-6"
                            style={{ marginLeft: "20px" }}
                          >
 <p
                            className="fw-bold"
                            style={{
                              fontFamily: "Inter, sans-serif",
                              fontSize: "20px",
                              color: "black",
                            }}
                          >
                            {SelectedSubCompany}
                          </p>{" "}
                            {/* <p
                              style={{
                                textAlign: "left",
                                fontFamily: "Inter, sans-serif",
                                fontSize: "20px",
                              }}
                            >
                              {responseData?.CompanyDetails &&
                                responseData?.CompanyDetails[0]?.CompanyAddress}
                            </p> */}
                            <p
                            style={{
                            //   textAlign: "right",
                              fontFamily: "Inter, sans-serif",
                              color: "black",
                            }}
                          >
                            {responseData?.CompanyDetails &&
                              responseData?.CompanyDetails[0]?.Website}
                          </p>{" "}
                          </div>
                          <div className="col-md-1"></div>
                          <div
                            className="col-md-4"
                            style={{ textAlign: "start" }}
                          >
                            <div
                              className="fw-bold"
                              style={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "14px",
                              }}
                            >
                              {responseData.SalesDetails[0]?.SalesType ===
                              "Sale"
                                ? "Invoice"
                                : responseData.SalesDetails[0]?.SalesType}
                            </div>

                            <div
                              className="fw-bold"
                              style={{
                                fontFamily: "Inter, sans-serif",
                                fontSize: "18px",
                              }}
                            >
                              Invoice No - {responseData.SalesDetails[0]?.Posid}
                            </div>
                          </div>
                        </div>

                        <div
                          className="row"
                          style={{ marginTop: "0px", marginTop: "-8px" }}
                        >
                          <div className="col-md-4">
                            {/* Optional content */}
                          </div>
                        </div>
                      </div>
                      <hr />
                    </div>
                  </div>

                  {/* Body */}
                  <div className="table-responsive" id="body">
                    <table className="table mt-1">
                      <thead>
                        <tr>
                          <th className="col-md">#</th>
                          <th className="col-md-3">Product/Services</th>

                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Price
                          </th>
                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Quantity
                          </th>
                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Discount %
                          </th>
                          {/* <th className="col-md-2" style={{ textAlign: "right" }}>
                            Tax %
                          </th> */}
                          <th
                            className="col-md-2"
                            style={{ textAlign: "right" }}
                          >
                            Total
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {responseData?.SalesItems?.map((item, index) => {
                          return (
                            <>
                              <tr key={index}>
                                <td
                                  style={{ color: "black" }}
                                  className="col-md"
                                >
                                  {++index}
                                </td>

                                <td
                                  style={{ textAlign: "left", color: "black" }}
                                  className="col-md-2"
                                >
                                  <div
                                    style={{ color: "black" }}
                                    className="col-md-2"
                                  >
                                    {buttonPrintLable ? (
                                      <p
                                        className="fw-bold"
                                        style={{
                                          fontFamily: "Inter, sans-serif",
                                        }}
                                      >
                                        {item?.ItemPrintName ||
                                        item?.ItemVariationPrintName
                                          ? item?.ItemVariationPrintName
                                            ? item?.ItemVariationPrintName
                                            : item?.ItemPrintName
                                          : item?.ItemVariationName
                                          ? item?.ItemVariationName
                                          : item?.ItemName}
                                      </p>
                                    ) : (
                                      <p
                                        className="fw-bold"
                                        style={{
                                          fontFamily: "Inter, sans-serif",
                                          color: "black",
                                        }}
                                      >
                                        {item?.ItemVariationName
                                          ? item?.ItemVariationName
                                          : item?.ItemName}
                                      </p>
                                    )}
                                  </div>

                                  {!buttonPrintLable ? (
                                    <p style={{ color: "black" }}>
                                      Item Number:
                                      {item.Itemnumber}
                                    </p>
                                  ) : (
                                    <></>
                                  )}
                                </td>
                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right", color: "black" }}
                                >
                                  {CurrencySymbols(
                                    Number(item.Itemunitprice),
                                    { CurrencySymbol },
                                    FractionDigits
                                  )}
                                </td>

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right", color: "black" }}
                                >
                                  {CurrencySymbols(
                                    Number(item.Quantitypurchased),
                                    "",
                                    FractionDigits
                                  )}
                                </td>

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right", color: "black" }}
                                >
                                  {Number(item.Discountpercent)}
                                </td>

                                <td
                                  className="col-md-2"
                                  style={{ textAlign: "right", color: "black" }}
                                >
                                  {CurrencySymbols(
                                    Number(item.Total),
                                    { CurrencySymbol },

                                    FractionDigits
                                  )}
                                </td>
                              </tr>
                            </>
                          );
                        })}
                      </tbody>
                    </table>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "2rem",
                      }}
                    >
                      {/* Left Section - Memo and Note */}
                      <div style={{ flex: 1, color: "black" }}>
                        <p style={{ margin: "0" }}>
                          <strong>Note to Customer: </strong>
                          {responseData.SalesDetails[0]?.Comment || ""}
                        </p>
                        <p style={{ margin: "0 0 10px 0" }}>
                          <strong>Memo on Statement: </strong>
                          {responseData.SalesDetails[0]?.InvoiceStatement || ""}
                        </p>
                      </div>
                      <div
                        style={{ textAlign: "right", color: "black" }}
                        className="mt-3"
                      >
                        <p style={{ margin: "0" }}>
                          <strong>Sub Total: </strong>
                          <span style={{ color: "black" }}>
                            {CurrencySymbols(
                              Number(responseData.SalesDetails[0]?.Subtotal),
                              { CurrencySymbol },

                              FractionDigits
                            )}
                          </span>
                        </p>
                        <p style={{ margin: "0", color: "black" }}>
                          <strong>Tax : </strong>
                          <span style={{ color: "black" }}>
                            {CurrencySymbols(
                              Number(responseData.SalesDetails[0]?.Tax),
                              { CurrencySymbol },
                              FractionDigits
                            )}
                          </span>
                        </p>
                        <p style={{ margin: "0", color: "black" }}>
                          <strong>Discount: </strong>
                          <span style={{ color: "black" }}>
                            {CurrencySymbols(
                              Number(
                                responseData.SalesDetails[0]?.Discountentiresale
                              ),
                              { CurrencySymbol },

                              FractionDigits
                            )}
                          </span>
                        </p>
                        <p style={{ margin: "0", color: "black" }}>
                          <strong>DeliveryFees : </strong>
                          <span style={{ color: "black" }}>
                            {CurrencySymbols(
                              Number(
                                responseData.SalesDeliveryDetails[0]
                                  ?.DeliveryFees || 0
                              ),
                              { CurrencySymbol },
                              FractionDigits
                            )}
                          </span>
                        </p>
                        <p style={{ margin: "0", color: "black" }}>
                          <strong>Total Amount: </strong>
                          <span style={{ color: "black" }}>
                            {CurrencySymbols(
                              Number(responseData.SalesDetails[0]?.Total),
                              { CurrencySymbol },

                              FractionDigits
                            )}
                          </span>
                        </p>
                      </div>
                    </div>
                    <hr />
                  </div>

                  {/* Footer */}
                  <div style={{ display: "none" }}>
                    <div id={"Totalfooter" + index}>
                      <div className="row">
                        <div className="col-md-6">
                          <p style={{ margin: "0", color: "black" }}>
                            <strong>Note to customer: </strong>
                            {responseData.SalesDetails[0]?.Comment}
                          </p>
                          <p style={{ margin: "0", color: "black" }}>
                            <strong>Memo on statement: </strong>
                            {responseData.SalesDetails[0]?.InvoiceStatement}
                          </p>
                        </div>

                        <div
                          style={{ textAlign: "right", color: "black" }}
                          className=" col-md-6"
                        >
                          <p style={{ margin: "0" }}>
                            <strong>Sub Total: </strong>{" "}
                            {CurrencySymbols(
                              Number(responseData.SalesDetails[0]?.Subtotal),
                              { CurrencySymbol },
                              FractionDigits
                            )}
                          </p>
                          <p style={{ margin: "0" }}>
                            <strong>Total item : </strong>

                            {CurrencySymbols(
                              Number(salesItemLength),
                              "",
                              FractionDigits
                            )}
                          </p>
                          <p style={{ margin: "0" }}>
                            <strong>Total Qty : </strong>

                            {CurrencySymbols(Number(sumss), "", FractionDigits)}
                          </p>
                          {(responseData.SalesDeliveryDetails[0]
                            ?.DeliveryFees || 0) > 0 && (
                            <p style={{ margin: "0", color: "black" }}>
                              <strong>DeliveryFees : </strong>
                              <span style={{ color: "black" }}>
                                {CurrencySymbols(
                                  Number(
                                    responseData.SalesDeliveryDetails[0]
                                      ?.DeliveryFees || 0
                                  ),
                                  { CurrencySymbol },
                                  FractionDigits
                                )}
                              </span>
                            </p>
                          )}
                          <p style={{ margin: "0" }}>
                            <strong>Total Amount: </strong>
                            {CurrencySymbols(
                              Number(responseData.SalesDetails[0]?.Total),
                              { CurrencySymbol },
                              FractionDigits
                            )}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="row" id={"footer" + index}>
                      <div className="row">
                        <p
                          style={{
                            marginTop: "20px",
                            textAlign: "center",
                            fontSize: "10px",
                            color: "black",
                          }}
                        >
                          BY SIGNING AND ACCEPTING THE ORDER CUSTOMER AGREES
                          THAT THE INFORMATION ABOVE IS TRUE & THEREFORE IS
                          RESPONSIBLE FOR THE ENTIRE BALANCE ON THE INVOICE. ALL
                          CREDIT MUST BE APPROVED BY THE OFFICE. NO RETURNS
                          ACCEPTED. NO RETURN/EXCHANGE ON ANY ELECTRONIC
                          CIGARETTES OR VAPE ITEMS NO EXCEPTIONS. OVER 5000+
                          CONVENIENCE STORE ITEMS GENERAL MERCHANDISE. QUICK
                          DELIVERY..LOW PRICES. THERE IS $35 BANK FEE FOR ALL
                          RETURNED CHECKS. CUSTOMER IS RESPONSIBLE FOR ALL STATE
                          AND LOCAL TAXES. SALE OF FLAVORED VAPES NOT ALLOWED IN
                          CERTAIN STATES, CUSTOMER IS RESPONSIBLE FOR ALL STATE
                          AND LOCAL COMPLIANCE RULES AND REGULATIONS.{" "}
                        </p>

                        <div
                          className="d-flex"
                          style={{
                            position: "relative",
                            justifyContent: "space-between",
                            padding: "20px",
                            color: "black",
                          }}
                        >
                          <div style={{ gap: "50px" }}>
                            <p style={{ marginTop: "30px", color: "black" }}>
                              {" "}
                              Customer Signature: ____________________________{" "}
                            </p>
                            <p style={{ marginTop: "25px", color: "black" }}>
                              {" "}
                              Date: ___________________________{" "}
                            </p>
                          </div>

                          {/* Second div aligned to the right and placed inside a box */}
                          <div
                            style={{
                              border: "1px solid black",
                              padding: "10px",
                              width: "300px",
                              position: "absolute",
                              right: "0",
                              top: "40px",
                              color: "black",
                            }}
                          >
                            <p style={{ marginTop: "10px", color: "black" }}>
                              {" "}
                              PREPARED BY: _________________________{" "}
                            </p>
                            <p style={{ marginTop: "20px", color: "black" }}>
                              {" "}
                              CHECKED BY: __________________________{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default PrintSaleReceipts;
